import {
  ONE_DAY_IN_SEC,
  ONE_HOUR_IN_SEC,
  ONE_MINUTE_IN_SEC,
  ONE_SECOND_MS,
} from '@/constants/time'

const FIVE_MINUTES_IN_SECONDS = 300

enum RelativeTimeRange {
  Days = 'days',
  Hours = 'hours',
  Minutes = 'minutes',
  Seconds = 'seconds',
}

type RemainTimeConfig = {
  unit: RelativeTimeRange
  count: number
}

// helper for formatting seconds in hours/minutes for errors
export const formatSecondsToDaysOrHoursOrMinutes = (
  seconds?: number
): RemainTimeConfig => {
  if (!seconds) {
    return {
      count: 0,
      unit: RelativeTimeRange.Seconds,
    }
  }

  const days = getDaysFromSeconds(seconds)

  if (days >= 1) {
    return {
      count: days,
      unit: RelativeTimeRange.Days,
    }
  }

  const hours = Math.floor(getHoursFromSeconds(seconds) % 24)

  if (hours >= 1) {
    return {
      count: hours,
      unit: RelativeTimeRange.Hours,
    }
  }

  const minutes = Math.floor(getMinutesFromSeconds(seconds) % 60)

  if (seconds > FIVE_MINUTES_IN_SECONDS) {
    return {
      count: minutes,
      unit: RelativeTimeRange.Minutes,
    }
  }

  return {
    count: seconds,
    unit: RelativeTimeRange.Seconds,
  }
}

const getDaysFromSeconds = (seconds: number): number =>
  Math.floor(seconds / ONE_DAY_IN_SEC)
const getHoursFromSeconds = (seconds: number): number =>
  Math.floor(seconds / ONE_HOUR_IN_SEC)
const getMinutesFromSeconds = (seconds: number): number =>
  Math.floor(seconds / ONE_MINUTE_IN_SEC)

export const getCurrentTimeSEC = (): number =>
  Math.round(Date.now() / ONE_SECOND_MS)
